import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';
import {
  BsTelephoneFill,
  BsWhatsapp,
  BsEnvelopeFill,
  BsGeoAltFill,
} from "react-icons/bs";

function Mumbaitogoacabs() {



const cardData = {
  keyword: "Mumbai to Goa Cabs",

headingDescription:
  "Omshree Cab offers reliable and comfortable Mumbai to Goa cab services for travelers who want a smooth and enjoyable journey to one of India’s most popular beach destinations. Whether you are planning a relaxing vacation, a romantic honeymoon, a fun trip with friends, or a corporate outing, our cab service from Mumbai to Goa ensures safe and convenient travel with experienced drivers and well-maintained vehicles. We provide flexible booking options including one-way cab service, round-trip packages, and multi-day travel plans at transparent and affordable per-kilometer pricing. Our fleet includes air-conditioned sedans, spacious SUVs, luxury cars, and tempo travelers, making it ideal for solo travelers, couples, families, and large groups. Our professional chauffeurs are experienced in long-distance highway driving and ensure a comfortable ride through scenic coastal routes. With punctual pickup from any location in Mumbai and 24/7 customer support, Omshree Cab is your trusted partner for dependable and affordable Mumbai to Goa cab services.",


topPlaces: [
  {
    title: "Baga Beach",
    description:
      "Baga Beach is one of the most famous beaches in Goa, known for its vibrant nightlife, water sports, and beachside shacks. Visitors can enjoy activities like parasailing, jet skiing, and banana boat rides while relaxing along the lively coastline."
  },
  {
    title: "Calangute Beach",
    description:
      "Calangute Beach is often called the Queen of Beaches and is one of the most visited beaches in Goa. The beach is known for its golden sand, water sports, and numerous restaurants and shops nearby, making it a favorite destination for tourists."
  },
  {
    title: "Dudhsagar Waterfalls",
    description:
      "Dudhsagar Waterfalls is one of the tallest waterfalls in India and a spectacular natural attraction near Goa. Surrounded by lush forests of the Western Ghats, the waterfall looks like a stream of milk flowing down the mountains, especially during the monsoon season."
  },
  {
    title: "Basilica of Bom Jesus",
    description:
      "The Basilica of Bom Jesus is a UNESCO World Heritage Site and one of the most important churches in Goa. It is famous for housing the mortal remains of St. Francis Xavier and features beautiful Baroque-style architecture."
  },
  {
    title: "Fort Aguada",
    description:
      "Fort Aguada is a historic Portuguese fort located near the Arabian Sea. The fort offers panoramic views of the coastline and is known for its lighthouse and well-preserved architecture, making it a popular sightseeing spot."
  },
  {
    title: "Anjuna Beach",
    description:
      "Anjuna Beach is known for its laid-back atmosphere, flea markets, and beautiful rocky shoreline. It is a favorite spot for travelers looking to enjoy sunsets, beach cafes, and Goa’s famous Wednesday flea market."
  },
  {
    title: "Chapora Fort",
    description:
      "Chapora Fort offers breathtaking views of the Vagator Beach and surrounding coastline. The historic fort became even more popular after appearing in the Bollywood movie 'Dil Chahta Hai' and is now a favorite photography spot."
  },
  {
    title: "Vagator Beach",
    description:
      "Vagator Beach is known for its dramatic red cliffs, scenic views, and relaxed atmosphere. The beach attracts visitors who want to enjoy peaceful surroundings along with beautiful sunset views."
  },
  {
    title: "Colva Beach",
    description:
      "Colva Beach is one of the most beautiful beaches in South Goa, known for its long stretch of white sand and swaying coconut trees. It is perfect for relaxing walks, water activities, and enjoying local Goan seafood."
  },
  {
    title: "Palolem Beach",
    description:
      "Palolem Beach is famous for its crescent-shaped shoreline, calm waters, and scenic beauty. It is a great destination for swimming, kayaking, and enjoying peaceful beachside cafes and sunset views."
  }
],

services: [
{
name: "Mumbai to Mahabaleshwar Cab",
description: "Mumbai to Mahabaleshwar cab service offers comfortable and reliable transportation for travelers heading to the beautiful hill station. Our AC sedans, SUVs, and premium vehicles ensure a smooth and relaxing highway journey. Professional drivers are experienced in ghat road driving for safe travel. Pickup is available from any location in Mumbai including homes, hotels, and airports. Ideal for family vacations, couples trips, and weekend getaways. Omshree Cab guarantees punctual service and stress-free hill station travel."
},
{
name: "Mumbai to Mahabaleshwar Taxi",
description: "Mumbai to Mahabaleshwar taxi service provides safe and convenient intercity travel for tourists and families. Comfortable AC vehicles ensure relaxed long-distance journeys from Mumbai to the scenic hill station. Our experienced drivers handle highway and ghat routes professionally. Flexible pickup options are available across Mumbai. Ideal for weekend trips and holiday travel. Omshree Cab ensures dependable taxi service with transparent pricing."
},
{
name: "Mumbai to Mahabaleshwar Cab Service",
description: "Mumbai to Mahabaleshwar cab service is perfect for travelers planning a comfortable hill station journey. Well-maintained vehicles and trained drivers ensure safe and smooth travel. Pickup is available from homes, offices, hotels, and Mumbai airport. Spacious seating and AC comfort improve the long-distance travel experience. Suitable for family tours and group travel. Omshree Cab offers reliable intercity cab services."
},
{
name: "Mumbai to Mahabaleshwar Taxi Fare",
description: "Mumbai to Mahabaleshwar taxi fare is calculated with transparent pricing and competitive per-km rates. Customers receive clear fare details without hidden charges. AC vehicles and experienced drivers ensure comfortable travel to the hill station. Ideal for budget-friendly travel planning. Flexible vehicle options include sedan, SUV, and premium cars. Omshree Cab provides affordable taxi fares for Mahabaleshwar travel."
},
{
name: "Cab from Mumbai to Mahabaleshwar",
description: "Cab from Mumbai to Mahabaleshwar offers a convenient way to travel comfortably to the popular hill station. AC cars with spacious seating ensure relaxed highway journeys. Professional drivers ensure safe travel through scenic ghat roads. Pickup is available from all areas in Mumbai. Perfect for family holidays and weekend trips. Omshree Cab ensures reliable cab service for hill station travel."
},
{
name: "Taxi from Mumbai to Mahabaleshwar",
description: "Taxi from Mumbai to Mahabaleshwar provides dependable long-distance transportation for tourists and families. Comfortable AC vehicles ensure a smooth ride from the city to the hill station. Experienced drivers ensure safe driving on highways and hill routes. Ideal for couples, families, and group travelers. Flexible booking options make travel planning easier. Omshree Cab ensures comfortable taxi travel."
},
{
name: "Mumbai to Mahabaleshwar Cab Booking",
description: "Mumbai to Mahabaleshwar cab booking allows travelers to reserve vehicles quickly for hill station trips. The easy booking process ensures instant confirmation and reliable service. Our fleet includes sedan, SUV, and premium vehicles for different travel needs. Professional drivers ensure safe and comfortable travel. Ideal for holiday tours and weekend trips. Omshree Cab offers smooth cab booking service."
},
{
name: "Mumbai to Mahabaleshwar Taxi Booking Online",
description: "Online taxi booking from Mumbai to Mahabaleshwar allows passengers to reserve vehicles instantly from anywhere. Quick confirmation and flexible scheduling make travel planning simple. AC vehicles and professional drivers ensure comfortable long-distance travel. Ideal for tourists visiting Mahabaleshwar for leisure trips. Online booking helps avoid last-minute travel issues."
},
{
name: "Mumbai to Mahabaleshwar Cab Price",
description: "Mumbai to Mahabaleshwar cab price is designed to offer affordable travel options for different budgets. Customers can choose sedan, SUV, or luxury vehicles based on their needs. Transparent fare structure ensures no hidden charges. AC comfort and professional drivers ensure relaxed journeys. Perfect for family vacations and group travel."
},
{
name: "Mumbai to Mahabaleshwar Taxi Charges",
description: "Mumbai to Mahabaleshwar taxi charges are calculated with clear per-km rates and simple billing structure. Travelers can select from various vehicles depending on group size and comfort preference. Professional drivers ensure safe travel on highway and hill roads. Ideal for both budget and premium travel plans. Omshree Cab provides competitive taxi charges."
},
{
name: "Mumbai to Mahabaleshwar One Way Cab",
description: "One way cab from Mumbai to Mahabaleshwar is ideal for travelers who only require drop service without paying return charges. This option helps reduce travel cost while providing comfortable transportation. AC vehicles ensure smooth highway travel. Professional drivers ensure safe ghat road driving. Perfect for one-way travel plans."
},
{
name: "Mumbai to Mahabaleshwar Round Trip Taxi",
description: "Round trip taxi from Mumbai to Mahabaleshwar provides complete travel convenience for tourists planning return journeys. Flexible return timing allows travelers to explore Mahabaleshwar comfortably. Vehicles remain available for the full travel duration. Ideal for weekend holidays and sightseeing tours. Omshree Cab ensures smooth round-trip travel experience."
},
{
name: "Mumbai to Mahabaleshwar Innova Cab",
description: "Innova cab from Mumbai to Mahabaleshwar offers spacious and comfortable travel for families and groups. The premium MPV provides ample seating and luggage capacity. AC comfort and smooth suspension improve long-distance travel experience. Ideal for hill station family tours. Professional drivers ensure safe ghat road driving."
},
{
name: "Mumbai to Mahabaleshwar Ertiga Cab",
description: "Ertiga cab from Mumbai to Mahabaleshwar is a great option for medium-size families traveling together. Spacious interiors ensure comfortable seating for long-distance travel. AC comfort keeps passengers relaxed throughout the journey. Ideal for budget-friendly hill station trips. Professional drivers ensure safe highway travel."
},
{
name: "Mumbai to Mahabaleshwar Sedan Cab",
description: "Sedan cab from Mumbai to Mahabaleshwar offers economical travel for couples and small families. Vehicles like Swift Dzire and Etios provide comfortable seating and smooth travel. AC comfort and professional drivers ensure stress-free journeys. Ideal for weekend trips and sightseeing tours."
},
{
name: "Mumbai to Mahabaleshwar SUV Taxi",
description: "SUV taxi from Mumbai to Mahabaleshwar is perfect for group travelers requiring extra space and luggage capacity. Powerful vehicles ensure stable driving on highways and ghat roads. Spacious interiors ensure comfort for long journeys. Ideal for family tours and adventure travel. Professional drivers ensure safe and reliable transportation."
}
],

tableData: [
["Mumbai to Mahabaleshwar Cab","Mumbai to Mahabaleshwar Taxi"],
["Mumbai to Mahabaleshwar Cab Service","Mumbai to Mahabaleshwar Taxi Fare"],
["Cab from Mumbai to Mahabaleshwar","Taxi from Mumbai to Mahabaleshwar"],
["Mumbai to Mahabaleshwar Cab Booking","Mumbai to Mahabaleshwar Taxi Booking Online"],
["Mumbai to Mahabaleshwar Cab Price","Mumbai to Mahabaleshwar Taxi Charges"],
["Mumbai to Mahabaleshwar One Way Cab","Mumbai to Mahabaleshwar Round Trip Taxi"],
["Mumbai to Mahabaleshwar Innova Cab","Mumbai to Mahabaleshwar Ertiga Cab"],
["Mumbai to Mahabaleshhwar Sedan Cab","Mumbai to Mahabaleshwar SUV Taxi"]
],




whychoose: [
  {
    WhyChooseheading: "Experienced Hill Route Drivers",
    WhyChoosedescription: "Our drivers are highly experienced in driving through the winding hill roads and ghat sections between Mumbai and Mahabaleshwar. They understand the terrain, curves, and weather conditions of the Western Ghats, ensuring a safe, comfortable, and relaxed journey for passengers traveling to this beautiful hill station."
  },
  {
    WhyChooseheading: "Transparent Pricing",
    WhyChoosedescription: "Omshree Cabs offers clear and honest pricing for Mumbai to Mahabaleshwar cab services. Our per-kilometer rates and package fares are shared in advance, so you never face hidden charges or unexpected costs during your journey."
  },
  {
    WhyChooseheading: "24/7 Cab Availability",
    WhyChoosedescription: "Whether you want to start early in the morning to enjoy the sunrise in Mahabaleshwar or travel late at night, Omshree Cabs provides 24/7 booking and support. Our team ensures quick confirmation and reliable service at any time."
  },
  {
    WhyChooseheading: "Clean & Comfortable AC Cars",
    WhyChoosedescription: "All vehicles in our fleet are air-conditioned, well-maintained, and thoroughly cleaned before every trip. Long journeys from Mumbai to Mahabaleshwar become more enjoyable when you travel in a fresh, hygienic, and comfortable vehicle."
  },
  {
    WhyChooseheading: "Flexible Trip Options",
    WhyChoosedescription: "We offer flexible travel packages including one-way cab, round trip, or multi-day Mahabaleshwar tour options. Whether you are planning a quick weekend getaway or a longer holiday, Omshree Cabs adapts to your travel schedule."
  },
  {
    WhyChooseheading: "Wide Range of Vehicles",
    WhyChoosedescription: "Choose from comfortable sedans, spacious SUVs, or premium luxury vehicles depending on your group size and travel preference. Omshree Cabs ensures the right vehicle for couples, families, and group travelers going to Mahabaleshwar."
  },
  {
    WhyChooseheading: "Doorstep Pickup from Mumbai",
    WhyChoosedescription: "Our cab service provides pickup directly from your home, hotel, office, or airport in Mumbai. This eliminates the hassle of traveling to a taxi stand and allows you to begin your journey to Mahabaleshwar conveniently."
  },
  {
    WhyChooseheading: "Reliable & On-Time Service",
    WhyChoosedescription: "Punctuality and customer satisfaction are our priorities. Omshree Cabs ensures that your Mumbai to Mahabaleshwar cab arrives on time, follows safe driving practices, and delivers a smooth travel experience from start to finish."
  }
]
};


const faqData = [
  { question: "How far is Mahabaleshwar from Mumbai by cab?", answer: "The distance from Mumbai to Mahabaleshwar is approximately 260 km and usually takes around 5–6 hours by cab depending on traffic and road conditions." },
  { question: "Do you provide one-way Mumbai to Mahabaleshwar cabs?", answer: "Yes, Omshree Cabs offers both one-way and round-trip cab services from Mumbai to Mahabaleshwar." },
  { question: "Which cars are available for this route?", answer: "Sedans, SUVs like Ertiga or Innova, and premium vehicles are available depending on your comfort and group size." },
  { question: "Is Mahabaleshwar a good weekend destination from Mumbai?", answer: "Yes, Mahabaleshwar is one of the most popular hill stations near Mumbai and is perfect for weekend trips, nature lovers, and family vacations." },
  { question: "Do drivers know the Mahabaleshwar tourist locations?", answer: "Yes, our drivers are familiar with Mahabaleshwar sightseeing places such as Mapro Garden, Venna Lake, and Arthur Seat Point." },
  { question: "Is AC provided in all cabs?", answer: "Yes, every cab provided by Omshree Cabs is fully air-conditioned for a comfortable long-distance journey." },
  { question: "Can I book a Mumbai Airport to Mahabaleshwar cab?", answer: "Yes, we provide direct pickup from Mumbai Airport for Mahabaleshwar trips." },
  { question: "Do you provide sightseeing packages in Mahabaleshwar?", answer: "Yes, we can arrange Mahabaleshwar sightseeing tours covering major attractions and viewpoints." },
  { question: "Is advance booking required?", answer: "Advance booking is recommended, especially during weekends and holiday seasons, to ensure vehicle availability." },
  { question: "Are vehicles sanitized for safety?", answer: "Yes, all vehicles are regularly cleaned and sanitized before every journey to ensure passenger safety and hygiene." }
];


const testimonials = [
  {
    id: 1,
    name: "Mr. Amit Desai",
    feedback:
      "Booked Omshree Cabs for a Mumbai to Mahabaleshwar trip with family. The driver was very professional and knew the ghat roads well. The car was clean and the journey was very comfortable.",
    rating: 5
  },
  {
    id: 2,
    name: "Mrs. Pooja Shah",
    feedback:
      "Excellent cab service for our Mahabaleshwar weekend trip. On-time pickup from Mumbai, smooth drive through the hills, and very transparent pricing. Highly recommend Omshree Cabs.",
    rating: 5
  }
];




























































const Images = [
  { place: "/images/keyword/1.jpg", text: "Mumbai Outstation Cabs", link: "Mumbai-Outstation-Cab" },
{ place: "/images/keyword/2.jpeg", text: "Mumbai to Mahabaleshwar Cab", link: "Mumbai-to-Mahabaleshwar-Cab" },
{ place: "/images/keyword/3.jpg", text: "Mumbai to Goa Cabs", link: "Mumbai-to-Goa-Cabs" },
{ place: "/images/keyword/4.jpg", text: "Mumbai to Shirdi Cab", link: "Mumbai-to-Shirdi-Cab" },
{ place: "/images/keyword/5.jpeg", text: "Mumbai Nashik Cab", link: "Mumbai-Nashik-Cab" },
{ place: "/images/keyword/6.jpg", text: "Mumbai to Kolhapur Cab", link: "Mumbai-to-Kolhapur-Cab" },
{ place: "/images/keyword/7.jpeg", text: "Mumbai to Pune Cab", link: "Mumbai-to-Pune-Cab" },
{ place: "/images/keyword/8.jpg", text: "Mumbai to Aurangabad Cab", link: "Mumbai-to-Aurangabad-Cab" },
{ place: "/images/keyword/9.jpg", text: "Mumbai to Bhimashankar Cab", link: "Mumbai-to-Bhimashankar-Cab" },
{ place: "/images/keyword/10.jpg", text: "Mumbai to Ashtavinayak Cab Service", link: "Mumbai-to-Ashtavinayak-Cab-Service" },
{ place: "/images/keyword/11.jpeg", text: "Mumbai to 5 Jyotirlinga Cab", link: "Mumbai-to-5-Jyotirlinga-Cab" },
{ place: "/images/keyword/12.jpg", text: "Mumbai to Lonavala Cab", link: "Mumbai-to-Lonavala-Cab" },
{ place: "/images/keyword/13.jpg", text: "Mumbai to Konkan Darshan Cab Booking", link: "Mumbai-to-Konkan-Darshan-Cab-Booking" },
{ place: "/images/keyword/14.jpg", text: "Mumbai to Alibaug Cab", link: "Mumbai-to-Alibaug-Cab" },
{ place: "/images/keyword/15.jpg", text: "Mumbai to Ahmednagar Cab", link: "Mumbai-to-Ahmednagar-Cab" },
{ place: "/images/keyword/16.jpeg", text: "Mumbai to Matheran Cab", link: "Mumbai-to-Matheran-Cab" },
{ place: "/images/keyword/17.jpg", text: "Mumbai to Jalgaon Cab Booking / Dhule", link: "Mumbai-to-Jalgaon-Cab-Booking-Dhule" },
{ place: "/images/keyword/18.jpg", text: "Mumbai to Lavasa Cab", link: "Mumbai-to-Lavasa-Cab" },
{ place: "/images/keyword/19.jpg", text: "Mumbai to Panchgani Cab", link: "Mumbai-to-Panchgani-Cab" },
{ place: "/images/keyword/20.jpg", text: "Mumbai to Khandala Taxi Fare", link: "Mumbai-to-Khandala-Taxi-Fare" },
{ place: "/images/keyword/21.jpeg", text: "Mumbai to Surat Cab", link: "Mumbai-to-Surat-Cab" },
{ place: "/images/keyword/22.jpg", text: "Mumbai to Ahmedabad Cab", link: "Mumbai-to-Ahmedabad-Cab" },
];












const jsonData = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Mumbai to Goa Cabs",
  "description": "Book Mumbai to Goa Cabs with Omshree Cab for comfortable and reliable outstation travel. Choose from Innova, Ertiga, Sedan, and SUV cabs for one-way, round trips, or family trips. Enjoy affordable rates, easy online booking, and trusted taxi service from Mumbai to Goa.",
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.9",
    "ratingCount": "4100"
  }
};





  return (
    <div>
      
<Helmet>
  <title>Mumbai to Goa Cabs | Contact: +91 9892544084 | Omshree Cab</title>
  <meta 
    name="description" 
    content="Book Mumbai to Goa Cabs with Omshree Cab for comfortable and reliable outstation travel. Choose from Innova, Ertiga, Sedan, and SUV cabs for one-way, round trips, or family trips. Enjoy affordable rates, easy online booking, and trusted taxi service from Mumbai to Goa." 
  />
  <script type="application/ld+json">
    {JSON.stringify(jsonData)}
  </script>
</Helmet>


 <div className="breadcrumb-bar">
      <div className="container">
        <div className="row align-items-center text-center">
          <div className="col-md-12 col-12">
            <h2 className="breadcrumb-title"> {cardData.keyword}</h2>
           
          </div>
        </div>
      </div>
    </div>




      








      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/3.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >Omshree Cabs: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                {/* <p className="sectionLead">{cardData.top}</p> */}
              
     <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                  
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>

              
              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                    <div className="service-icon">
                      🚙
                    </div>
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              {/* <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable /> */}

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Omshree Cab</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Omshree Cab </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
       <div className="pc-contact">
      <h4 className="pc-title">Contact Information</h4>

      <div className="pc-grid">
        {/* Phones */}
        <section className="pc-tile">
          <header className="pc-tile-head">
            <BsTelephoneFill className="pc-icon" />
            <span>Phone Numbers</span>
          </header>

          <div className="pc-list">
            <a href="tel:+919892544084" className="pc-call">
              +91 9892544084
            </a>
          </div>

          <div className="pc-cta">
            <a
              href="https://wa.me/919892544084"
              target="_blank"
              rel="noopener noreferrer"
              className="pc-whats"
            >
              <BsWhatsapp /> WhatsApp
            </a>

            <a href="tel:+919892544084" className="pc-primary">
              Call Now
            </a>
          </div>
        </section>

        {/* Email */}
        <section className="pc-tile">
          <header className="pc-tile-head">
            <BsEnvelopeFill className="pc-icon" />
            <span>Email</span>
          </header>

          <a href="mailto:booking@omshreecabs.com" className="pc-email">
            booking@omshreecabs.com
          </a>
        </section>

        {/* Address */}
        <section className="pc-tile">
          <header className="pc-tile-head">
            <BsGeoAltFill className="pc-icon" />
            <span>Address</span>
          </header>

          <address className="pc-address">
            <strong>Omshree Cab</strong>
            <br />
           Shri Omkar Co-op Housing Society,
            <br />
            E-11/101, Sector 9,
Ghansoli (Gharonda),
            <br />
            Navi Mumbai, Maharashtra, India - 400701
          </address>
        </section>
      </div>
    </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Mumbaitogoacabs;